import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { District, Province, Region, Ubigeo } from '../../shared/models/catalog/ubigeo';

export const ubigeoApi = createApi({
  reducerPath: 'ubigeoApi',
  baseQuery,
  tagTypes: ['Ubigeos'],
  endpoints: (builder) => ({
    getUbigeos: builder.query<Ubigeo[], void>({
      query: () => '/api/ubigeos?Size=10000',
      transformResponse: (response: { results: Ubigeo[] }) => response.results,
      providesTags: ['Ubigeos'],
    }),
    regionList: builder.query<Region[], { hasZoneId?: boolean }>({
      query: ({ hasZoneId }) => ({
        url: `/api/ubigeos/regions${hasZoneId ? '?hasZoneId=' + hasZoneId : ''}`,
        method: 'GET',
      }),
    }),
    provinceList: builder.query<Province[], { regionName: string; hasZoneId?: boolean }>({
      query: ({ regionName, hasZoneId }) => ({
        url: `/api/ubigeos/regions/${regionName}${hasZoneId ? '?hasZoneId=' + hasZoneId : ''}`,
        method: 'GET',
      }),
    }),
    districtList: builder.query<
      District[],
      { regionName: string; provinceName: string; hasZoneId?: boolean }
    >({
      query: ({ regionName, provinceName, hasZoneId }) => ({
        url: `/api/ubigeos/regions/${regionName}/provinces/${provinceName}${hasZoneId ? '?hasZoneId=' + hasZoneId : ''}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetUbigeosQuery,
  useRegionListQuery,
  useLazyProvinceListQuery,
  useLazyDistrictListQuery,
} = ubigeoApi;
